/** Extrai o código de convite de `/invite/<codigo>`; null para qualquer outra rota. */
export function parseInvitePath(pathname: string): string | null {
  const match = pathname.match(/^\/invite\/([^/]+)\/?$/);
  return match ? decodeURIComponent(match[1]!) : null;
}

/** A rota de redefinição de senha recebe o token de recovery do Supabase no hash. */
export function isResetPasswordPath(pathname: string): boolean {
  return pathname === "/reset-password" || pathname === "/reset-password/";
}
